import { Button, Stack, styled } from '@mui/material';
import { Caption } from '@/components/@IntranetLibrary/Typography';

export const PaginationContainer = styled(Stack)`
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  user-select: none;
  &.normal {
    gap: 4px;
  }
  &.frosted {
    gap: 4px;
  }
`;

export const PaginationButton = styled(Button)`
  // 아이콘 svg 는 width/height 가 100% 라 부모 크기에 기대는데, iOS 웹뷰에서는
  // 이 값이 0 으로 잡혀 화살표가 그려지지 않는다. 버튼 안쪽 크기만큼 픽셀로 못박는다.
  .normal & {
    width: 20px;
    height: 20px;
    padding: 0;
    border: 1px solid #e7e9ec;
    border-radius: 2px;
    svg {
      width: 18px;
      height: 18px;
    }
    &:disabled {
      svg {
        path {
          stroke: #d1d8e2;
        }
      }
    }
  }
  .frosted & {
    width: 28px;
    height: 28px;
    padding: 4px;
    border-radius: 50%;
    // frosted 처리
    background: linear-gradient(
        180deg,
        rgba(102, 102, 102, 0.2) 0%,
        rgba(102, 102, 102, 0) 32.69%
      ),
      linear-gradient(
        180deg,
        rgba(102, 102, 102, 0) 50%,
        rgba(102, 102, 102, 0.4) 100%
      ),
      rgba(0, 0, 0, 0.24);
    background-blend-mode: color-dodge, color-dodge, normal;
    box-shadow: 2px 1px 1px -2px #b3b3b3 inset, -2px -1px 1px -2px #b3b3b3 inset,
      0 0 22px 0 rgba(242, 242, 242, 0.5) inset,
      0 4px 32px 0 rgba(0, 0, 0, 0.08);
    backdrop-filter: blur(2px);

    svg {
      width: 20px;
      height: 20px;
      path {
        stroke: white;
      }
    }
  }
`;

export const PageText = styled(Caption)`
  text-align: center;
  line-height: 20px;
  font-variant-numeric: tabular-nums;
  .normal & {
    width: 52px;
    padding: 0;
    font-size: 14px;
    & .curr-page {
      color: #000;
    }
  }
  .frosted & {
    width: 69px;
    padding: 4px 0;
    font-size: 12px;
    color: #d4d7db;
    border-radius: 999px;
    // frosted 처리
    background: linear-gradient(
        180deg,
        rgba(102, 102, 102, 0.2) 0%,
        rgba(102, 102, 102, 0) 32.69%
      ),
      linear-gradient(
        180deg,
        rgba(102, 102, 102, 0) 50%,
        rgba(102, 102, 102, 0.4) 100%
      ),
      rgba(0, 0, 0, 0.24);
    background-blend-mode: color-dodge, color-dodge, normal;
    box-shadow: 2px 1px 1px -2px #b3b3b3 inset, -2px -1px 1px -2px #b3b3b3 inset,
      0 0 22px 0 rgba(242, 242, 242, 0.5) inset,
      0 4px 32px 0 rgba(0, 0, 0, 0.08);
    backdrop-filter: blur(2px);
    & .curr-page {
      line-height: 20px;
      font-variant-numeric: tabular-nums;
      color: white;
    }
  }
`;
